/**
 * Asynchronously loads the component for DocumentImport
 */

import { lazyLoad } from 'utils/loadable';

export const DocumentImport = lazyLoad(
  () => import('./index'),
  module => module.DocumentImport,
);
